import React, { useState } from "react";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { Link, useLocation } from "react-router-dom";
import DialogBox from "../ui/DialogBox";

function Navbar() {
  const [openSideBar, setOpenSideBar] = useState(false); // For mobile device sidebar
  const [active, setActive] = useState(false); //hamburger menu sticky
  const [isOpen, setIsOpen] = useState(false); // For popup box open signIn
  const { pathname } = useLocation();
  const menus = [
    {
      name: "Home",
      path: "/",
    },
    {
      name: "About",
      path: "/about",
    },
    {
      name: "Departments",
      path: "/departments",
    },
    {
      name: "Doctors",
      path: "/doctors",
    },
    {
      name: "Blog",
      path: "/blog",
    },
    {
      name: "Contact",
      path: "/contact",
    },
  ];

  if (typeof Window !== "undefined") {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 85) {
        setActive(true);
      } else {
        setActive(false);
      }
    });
  }

  return (
    <>
      <DialogBox visible={isOpen} close={() => setIsOpen(false)} />
      <nav
        className={
          active
            ? "bg-white px-5 sm:px-7 lg:px-14 xl:px-48 border-b shadow-b-md h-[80px] sticky z-50 top-0"
            : "bg-white px-5 sm:px-7 lg:px-14 xl:px-48 border-b shadow-b-md h-[80px] z-50"
        }
      >
        {/* ******************* Desktop ******************** */}
        <div className='flex justify-between items-center h-full'>
          <div>
            <Link to='/'>
              <p>Logo!</p>
            </Link>
          </div>
          <ul className='hidden md:flex items-center gap-5 h-full pt-0 md:pt-3'>
            {menus.map((element, index) => {
              return (
                <li
                  key={index}
                  className={`hover:text-primary ${
                    pathname === element.path ? "text-primary" : "text-gray-500"
                  }`}
                >
                  <Link to={element.path}>{element.name}</Link>
                </li>
              );
            })}
            <li
              onClick={() => {
                setIsOpen(true);
              }}
              className='bg-primary p-3 rounded-full text-white font-sans text-md hover:cursor-pointer'
            >
              Make an Appointment
            </li>
          </ul>
          <div className='md:hidden text-gray-500'>
            {openSideBar ? (
              // close Icon
              <button
                onClick={() => {
                  setOpenSideBar(false);
                }}
              >
                <AiOutlineClose size={25} />
              </button>
            ) : (
              // Open Icon
              <button
                onClick={() => {
                  setOpenSideBar(true);
                }}
              >
                <AiOutlineMenu size={25} />
              </button>
            )}
          </div>
        </div>
      </nav>
      {/* ******************* Mobile Device ******************** */}
      <div
        className={`h-[calc(100vh-80px)] w-full bg-white flex md:hidden justify-center items-center fixed z-50 ${
          openSideBar
            ? "translate-x-[0%] transition-all duration-[0.5s] ease-in-out"
            : "-translate-x-[100%] transition-all duration-[0.5s] ease-in-out"
        }`}
      >
        <div className='-mt-16'>
          <ul>
            {menus.map((element, index) => {
              return (
                <li
                  key={index}
                  className={`py-3 text-center text-xl hover:text-primary hover:cursor-pointer ${
                    pathname === element.path ? "text-primary" : "text-gray-500"
                  }`}
                  onClick={() => {
                    setOpenSideBar(false);
                  }}
                >
                  <Link to={element.path}>{element.name}</Link>
                </li>
              );
            })}
            <li
              onClick={() => {
                setOpenSideBar(false);
                setIsOpen(true);
              }}
              className='bg-primary p-3 rounded-full text-white font-sans text-md hover:cursor-pointer'
            >
              Make an Appointment
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Navbar;
